// extracted by mini-css-extract-plugin
module.exports = {"details":"LookupByIBO_details__TTRDh","iboListItem":"LookupByIBO_iboListItem__DQBDI","noSelection":"LookupByIBO_noSelection__2novy"};